/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { createContext, useContext } from 'react';
var ToastContext = createContext(undefined);
function useToast() {
    var context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('Make sure to wrap useToast with a ToastProvider.');
    }
    return context;
}
export { ToastContext, useToast };
